/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Segment_Event_Group_Number_Input_Aria_LabelInputs */

const en_segment_event_group_number_input_aria_label = /** @type {(inputs: Segment_Event_Group_Number_Input_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter number of segments`)
};

const fr_segment_event_group_number_input_aria_label = /** @type {(inputs: Segment_Event_Group_Number_Input_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrer le nombre de segments`)
};

const de_segment_event_group_number_input_aria_label = /** @type {(inputs: Segment_Event_Group_Number_Input_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geben Sie die Anzahl der Segmente ein.`)
};

const it_segment_event_group_number_input_aria_label = /** @type {(inputs: Segment_Event_Group_Number_Input_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci il numero di segmenti`)
};

const ru_segment_event_group_number_input_aria_label = /** @type {(inputs: Segment_Event_Group_Number_Input_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Введите количество сегментов`)
};

const es_segment_event_group_number_input_aria_label = /** @type {(inputs: Segment_Event_Group_Number_Input_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduzca el número de segmentos`)
};

const zh_cn2_segment_event_group_number_input_aria_label = /** @type {(inputs: Segment_Event_Group_Number_Input_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请输入段数`)
};

const ja_segment_event_group_number_input_aria_label = /** @type {(inputs: Segment_Event_Group_Number_Input_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`セグメント数を入力`)
};

const hi_segment_event_group_number_input_aria_label = /** @type {(inputs: Segment_Event_Group_Number_Input_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खंडों की संख्या दर्ज करें`)
};

const pt_pt2_segment_event_group_number_input_aria_label = /** @type {(inputs: Segment_Event_Group_Number_Input_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insira o número de segmentos`)
};

/**
* | output |
* | --- |
* | "Enter number of segments" |
*
* @param {Segment_Event_Group_Number_Input_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const segment_event_group_number_input_aria_label = /** @type {((inputs?: Segment_Event_Group_Number_Input_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Segment_Event_Group_Number_Input_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_segment_event_group_number_input_aria_label(inputs)
	if (locale === "de") return de_segment_event_group_number_input_aria_label(inputs)
	if (locale === "it") return it_segment_event_group_number_input_aria_label(inputs)
	if (locale === "ru") return ru_segment_event_group_number_input_aria_label(inputs)
	if (locale === "es") return es_segment_event_group_number_input_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_segment_event_group_number_input_aria_label(inputs)
	if (locale === "ja") return ja_segment_event_group_number_input_aria_label(inputs)
	if (locale === "hi") return hi_segment_event_group_number_input_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_segment_event_group_number_input_aria_label(inputs)
	return en_segment_event_group_number_input_aria_label(inputs)
});